import inView from "in-view";

export default class {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "scrollGallery";
		this.init();
	}

	init() {
		this.bindEvents(true);
	}

	bindEvents(bindDirection) {
		inView(".iv-trigger").on("enter", (el) => {
			let imgShow = $(el).parent().index();
			let galEl = $(el).closest(".section-scroll_gallery");
			$(el)
				.closest(".section-scroll_gallery")
				.find(".active")
				.removeClass("active");
			$(el)
				.closest(".section-scroll_gallery")
				.find(".media-" + imgShow)
				.addClass("active");
		});
	}

	destroy() {
		this.bindEvents(false);
	}
}
